import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { useAppContext } from "../../context/app-context";
import { useParams } from "react-router-dom";
import { useAcubeService } from "../../service/acube-api.hook";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { API_BASE_URL, APP_DOMAIN } from "../../utils/env";
import SkeletonScreen from "../../components/Skeleton/Skeleton";

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share";

const like =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/thumbs-up-unfilled.svg";
const likeFilled =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/thumbs-up-filled.svg";
const share =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/share-icon.svg";
const search =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/search-btn.svg";
const copyLink =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/link.svg";
const copySuccess =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/copied.svg"; // Success tick icon
// const closeIcon =
//   "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/close-menu.svg";

const CategoryPage = () => {
  const [blogData, setBlogData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentBlog, setCurrentBlog] = useState(null);
  const [isCopied, setIsCopied] = useState(false); // State to track if the link is copied
  const { ipAddress } = useAppContext();
  const { category } = useParams(); // Fetch UUID from the URL
  const decodedCategory = category.replace(/-/g, " ");
  const { getProxy, postProxy } = useAcubeService();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    const result = await getProxy(
      `blog/category/${decodedCategory}/${ipAddress}`
    );
    setBlogData(result.data);
    setIsLoading(false)
  };
  useEffect(() => {
    setIsLoading(true);
    if (ipAddress) fetchBlogs();
  }, [ipAddress]); // Dependency array is empty, so this effect runs only once after the initial render
  const formatDate = (dateString) => {
    return format(new Date(dateString), "d MMMM yyyy");
  };

  const handleCloseModal = () => setShowModal(false);

  const shareURL = currentBlog
    ? `${APP_DOMAIN}/resources/article/${currentBlog.slug}`
    : "";

  const socialMediaLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareURL}`,
    twitter: `https://twitter.com/intent/tweet?url=${shareURL}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${shareURL}`,
    email: `mailto:?subject=Check out this blog&body=Read this blog: ${shareURL}`, // Correct email URL
  };

  const handleCopy = () => {
    setIsCopied(true); // Change state to indicate the link is copied
  };
  const handleLikeClick = (blog) => {
    const payload = {
      blogUUID: blog.blog_uuid,
      ip: ipAddress,
    };

    postProxy(`blog/like`, payload)
      .then(async () => {
        fetchBlogs();
      })
      .catch((err) => {
        console.log("Error liking blog:", err);
      });
  };

  const handleShareClick = (blog) => {
    setCurrentBlog(blog);
    setShowModal(true);
    setIsCopied(false); // Reset copy state when modal opens
  };
  return (
    <section className="search-results">
      <Container fluid className="py-3">
        <h2 className="ft-wt-700 mb-4">Search Results for {decodedCategory}</h2>
        <Row className="blog-cards">
          {isLoading ? <SkeletonScreen count={6} /> : blogData && blogData.length > 0 ? (
            blogData.map((blog) => (
              <Col xs="12" md="6" lg="4" key={blog.id} className="mb-4 blog-card cursor-pointer">
                <img
                  src={blog.template_image}
                  alt={blog.title}
                  className="blog-thumbnail"
                />
                <div className="blog-card-info">
                  <div className="blog-meta">
                    <span className="author">{blog.service_category}</span>
                    <span className="date">{formatDate(blog.created_at)}</span>
                  </div>
                  <h3 className="blog-card-title">{blog.title}</h3>
                  <p className="blog-content">{blog.template_content}</p>
                  <div className="blog-actions d-flex justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={blog?.ip_logs?.length ? likeFilled : like}
                        alt="thumbs-up"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLikeClick(blog);
                        }}
                      />
                      <img
                        src={share}
                        alt="share"
                        onClick={() => handleShareClick(blog)}
                      />
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <h6 className="mb-0">{blog.likesAdded} likes</h6>
                      <h6 className="mb-0">{blog.views} views</h6>
                    </div>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col>
              <p>No results found for {decodedCategory}.</p>
            </Col>
          )}
        </Row>
      </Container>
      {/* Modal for sharing */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title className="ft-wt-700">Share This Article</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3 text-center">
              <Form.Label>Share to</Form.Label>
              <div className="d-flex gap-2 justify-content-center">
                <FacebookShareButton
                  url={socialMediaLinks.facebook}
                  className="mr-2"
                >
                  <FacebookIcon size={48} round />
                </FacebookShareButton>
                <TwitterShareButton
                  url={socialMediaLinks.twitter}
                  className="mr-2"
                >
                  <TwitterIcon size={48} round />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={socialMediaLinks.linkedin}
                  className="mr-2"
                >
                  <LinkedinIcon size={48} round />
                </LinkedinShareButton>
                <EmailShareButton url={socialMediaLinks.email} className="mr-2">
                  <EmailIcon size={48} round />
                </EmailShareButton>
              </div>
            </Form.Group>
            <Form.Group className="mb-3 position-relative">
              <Form.Label>Or copy the link</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control type="text" value={shareURL} readOnly />
                <CopyToClipboard text={shareURL} onCopy={handleCopy}>
                  <Button className="ms-2 p-0 copy-btn" variant="link">
                    <img
                      src={isCopied ? copySuccess : copyLink} // Change icon based on copy state
                      alt={isCopied ? "copied" : "copy"}
                      className="cursor-pointer"
                    />
                  </Button>
                </CopyToClipboard>
              </div>
              {isCopied && (
                <div className="link-success-msg">
                  Link copied successfully!
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="ft-wt-700 text-primary text-decoration-none"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default CategoryPage;
